import TitleBlock, { TitleDescription } from '@anm/components/TitleBlock';
import FieldWithButtonWrapper from '@anm/components/form/FieldWithButton/Wrapper';
import getFromCdn from '@anm/helpers/getFromCdn';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const mobileTitle = media.phone`
  font-size: 21px;
`;

export const Title = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4 {
    font-size: 24px;
    text-align: center;
    font-weight: 700;
    ${mobileTitle};
  }
  ${TitleDescription} {
    text-align: left;
    font-size: 16px;
    margin-top: 10px;
  }
`;

export const Wrapper = styled.div`
  max-width: 500px;
  ${FieldWithButtonWrapper} {
    margin-top: 15px;
  }
  button {
    margin-left: auto;
  }
`;

export const BottomLinksSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
  a {
    color: var(--blue_200);
    font-size: 16px;
    line-height: 22px;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const GuideLink = styled.a`
  background-image: url(${getFromCdn('images/streaming/external-link.svg')});
  background-position: right center;
  background-repeat: no-repeat;
  padding-right: 22px;
  background-size: 15px;
`;
